export const defaultMetatags = {
  title: 'Lami: Health delivery',
  description:
    'Prenota un servizio medico a domicilio in pochi passi, Massima attesa 24 ore!',
};
